import { __decorate, __metadata } from "tslib";
// NPM
import { Component, Prop, Mixins, Emit } from "vue-property-decorator";
// QUINLAN
import BaseMixer from "../../BaseMixer";
import { IMasterDTO } from "@/store/models/list/master";
let ListMasterUpsertComponent = /** @class */ (() => {
    var _a;
    let ListMasterUpsertComponent = class ListMasterUpsertComponent extends Mixins(BaseMixer) {
        checkAndSendSave() {
            this.validateProvider("listMasterNameValProvider").then((response) => {
                if (response) {
                    return this.save();
                }
            });
        }
        save() { }
        cancel() { }
    };
    __decorate([
        Prop(),
        __metadata("design:type", typeof (_a = typeof IMasterDTO !== "undefined" && IMasterDTO) === "function" ? _a : Object)
    ], ListMasterUpsertComponent.prototype, "model", void 0);
    __decorate([
        Emit(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], ListMasterUpsertComponent.prototype, "save", null);
    __decorate([
        Emit(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], ListMasterUpsertComponent.prototype, "cancel", null);
    ListMasterUpsertComponent = __decorate([
        Component
    ], ListMasterUpsertComponent);
    return ListMasterUpsertComponent;
})();
export default ListMasterUpsertComponent;
